import { PermissionAccessLevel } from '@/api/generated/schemas/permissionAccessLevel';
import type { MeResponsePermissions } from '@/api/generated/schemas/meResponsePermissions';
import type { GrantedPermissionLevel } from './types';

/**
 * Převod mapy oprávnění z `/api/auth/me` (backend enum `None`/`Read`/`Edit`) na FE reprezentaci
 * (`ReadonlyMap` s lowercase úrovněmi). `None` se z backendu neposílá; kdyby přišlo, zahodí se.
 */
export function permissionsFromApi(
  permissions: MeResponsePermissions
): ReadonlyMap<string, GrantedPermissionLevel> {
  const map = new Map<string, GrantedPermissionLevel>();
  for (const [key, level] of Object.entries(permissions)) {
    if (level === PermissionAccessLevel.Read) map.set(key, 'read');
    else if (level === PermissionAccessLevel.Edit) map.set(key, 'edit');
  }
  return map;
}
